var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-download.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 16.5L16 11.5H13V4.5H11V11.5H8L12 16.5Z",
    fill: "#00B45E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 18.5H4V11.5H2V18.5C2 19.603 2.897 20.5 4 20.5H20C21.103 20.5 22 19.603 22 18.5V11.5H20V18.5Z",
    fill: "#00B45E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.534b9b324a89b2836ab27d936933fd24.svg";
export { ForwardRef as ReactComponent };